import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  DashboardColumn,
  DashboardInstallationData,
  DashboardInstallationsSums,
  DataBooleanStatus,
  ViError,
} from '@vi-iot/client';
import {
  DashboardTileType,
  DashboardTileOrder,
  InstallationsForMultipleTileCompletePayload,
} from './dashboard.model';

export namespace DashboardActions {
  export const fetchTilesOrder = createActionGroup({
    source: '[DASHBOARD] Fetch Tiles Order',
    events: {
      attempt: emptyProps(),
      success: props<{
        tilesOrder: DashboardTileOrder[];
      }>(),
      error: props<{
        error: ViError;
      }>(),
    },
  });

  export const saveTilesOrder = createActionGroup({
    source: '[DASHBOARD] Save Tiles Order',
    events: {
      attempt: props<{
        tilesOrder: DashboardTileOrder[];
        showToastMsg: boolean;
        reloadGrid: boolean;
      }>(),
      success: emptyProps(),
      error: props<{
        error: ViError;
      }>(),
    },
  });

  export const getDashboard = createActionGroup({
    source: '[DASHBOARD] Get dashboard',
    events: {
      attempt: emptyProps(),
      success: props<{ columns: DashboardColumn[] }>(),
      error: props<{
        error: ViError;
      }>(),
    },
  });

  export const initInstallationsForMultipleTileTypes = createActionGroup({
    source: '[DASHBOARD] Init installations for multiple tile types',
    events: {
      attempt: props<{
        tileTypes: DashboardTileType[];
        maxItemsPerFetch: number;
      }>(),
      complete: props<{
        data: InstallationsForMultipleTileCompletePayload[];
      }>(),
    },
  });

  export const installationsForSingleTileType = createActionGroup({
    source: '[DASHBOARD] Installations for single tile type',
    events: {
      init: props<{
        tileType: DashboardTileType;
        tab?: string;
        maxItemsPerFetch: number;
      }>(),
      fetch: props<{
        tileType: DashboardTileType;
        tab?: string;
        maxItemsPerFetch: number;
      }>(),
      success: props<{
        tileType: DashboardTileType;
        installations: DashboardInstallationData[];
        tab?: string;
        maxItemsPerFetch: number;
      }>(),
      'no data to fetch': props<{
        tileType: DashboardTileType;
        tab?: string;
      }>(),
      error: props<{
        tileType: DashboardTileType;
        tab?: string;
        error: ViError;
      }>(),
    },
  });

  export const contractEndingSoon = createActionGroup({
    source: '[DASHBOARD] Contracts ending soon',
    events: {
      init: props<{
        maxItemsPerFetch: number;
      }>(),
      fetch: props<{
        maxItemsPerFetch: number;
      }>(),
      success: props<{
        installations: DashboardInstallationData[];
        maxItemsPerFetch: number;
      }>(),
      'no data to fetch': emptyProps(),
      error: props<{
        error: ViError;
      }>(),
    },
  });

  export const countInstallationsForTiles = createActionGroup({
    source: '[DASHBOARD] Count installations for tiles',
    events: {
      init: props<{
        tiles: DashboardTileType[];
        tab?: string;
      }>(),
      success: props<{
        installationsSums: DashboardInstallationsSums[];
      }>(),
      error: props<{
        error: ViError;
      }>(),
    },
  });

  export const whatsAppBannerInfo = createActionGroup({
    source: '[DASHBOARD] WhatsApp banner info',
    events: {
      attempt: emptyProps(),
      success: props<DataBooleanStatus>(),
      error: props<{ error: ViError }>(),
      updateValue: props<DataBooleanStatus>(),
    },
  });
}
